export default (conditions, name) => {
  const containsOr = conditions["contains"]["or"]
  const containsAnd = conditions["contains"]["and"]
  const notContainsOr = conditions["notContains"]["or"]
  const notContainsAnd = conditions["notContains"]["and"]
  let passes = true;
  if (name && name != "") {
    if (containsOr && containsOr.length > 0) {
      const nameContains = containsOr.map((keyword) => name.toLowerCase().includes(keyword.toLowerCase()))
      if (!nameContains.includes(true)) {
        passes = false
      }
    }
    if (containsAnd && containsAnd.length > 0) {
      const nameContains = containsAnd.map((keyword) => name.toLowerCase().includes(keyword.toLowerCase()))
      if (nameContains.includes(false)) {
        passes = false
      }
    }
    if (notContainsOr && notContainsOr.length > 0) {
      const nameNotContains = notContainsOr.map((keyword) => name.toLowerCase().includes(keyword.toLowerCase()))
      if (!nameNotContains.includes(false)) {
        passes = false
      }
    }
    if (notContainsAnd && notContainsAnd.length > 0) {
      const nameNotContains = notContainsAnd.map((keyword) => name.toLowerCase().includes(keyword.toLowerCase()))
      if (nameNotContains.includes(true)) {
        passes = false
      }
    }
  } else {
    passes = false;
  }

  return passes
};
